const reviews = [
  {
    name: "林小满",
    tag: "入坑一年",
    avatar: "L",
    text: "之前总在各大平台翻来翻去找不到好看的韩漫，直到发现这个榜单。跟着高分榜追了几部，部部都踩中我的点，真的治好了我的书荒。",
  },
  {
    name: "阿澈",
    tag: "老漫友",
    avatar: "澈",
    text: "分类推荐特别实用，恋爱党和热血党都能精准找到自己的菜。榜单说明写得也很走心，不是那种冷冰冰的评分罗列。",
  },
  {
    name: "小桃同学",
    tag: "学生党",
    avatar: "桃",
    text: "每周更新的新作榜救了我！更新速度超快，画风和剧情介绍都写得很准，跟着入坑基本不会踩雷，强烈安利。",
  },
];

export default function Testimonials() {
  return (
    <section id="about" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-medium text-secondary-800">
              <i className="ri-heart-3-line"></i> 读者口碑
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black text-foreground-900 md:text-4xl">关于我们与读者口碑</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              「漫游榜单」是一群资深韩漫爱好者的编辑团队，我们每天做的事情只有一件——把真正值得看的韩国漫画，按最真实的标准排给大家看。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们坚持独立、公正、不接软文的原则，所有榜单都基于读者评分与编辑部逐部审读，力求让每一份推荐都对得起你的追更时间。
            </p>
            <div className="mt-6 grid grid-cols-3 gap-4">
              {[
                { n: "6 年", l: "榜单沉淀" },
                { n: "30+", l: "资深小编" },
                { n: "98%", l: "读者满意度" },
              ].map((s) => (
                <div key={s.l} className="rounded-xl border border-background-200 bg-background-50 p-4 text-center">
                  <p className="font-heading text-2xl font-black text-primary-600">{s.n}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.l}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            {reviews.map((r) => (
              <figure
                key={r.name}
                className="rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-lg font-bold text-background-50">
                    {r.avatar}
                  </span>
                  <div>
                    <figcaption className="text-sm font-semibold text-foreground-900">{r.name}</figcaption>
                    <p className="text-xs text-foreground-500">{r.tag}</p>
                  </div>
                  <div className="ml-auto flex gap-0.5 text-primary-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs"></i>
                    ))}
                  </div>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">{r.text}</blockquote>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}